import api from '@/lib/api';

export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export interface LocalTime {
  hour: number;
  minute: number;
}

/** Exactly one of `stopTime` and `durationMinutes` is set. */
export interface RunnerSchedule {
  zoneId: string;
  startTime: LocalTime;
  stopTime: LocalTime | null;
  durationMinutes: number | null;
  daysOfWeek: DayOfWeek[];
  enabled: boolean;
}

function scheduleUrl(runnerId: string) {
  return `runner/${runnerId}/schedule`;
}

export async function getRunnerSchedule(runnerId: string): Promise<RunnerSchedule | null> {
  try {
    const { data } = await api.get<RunnerSchedule>(scheduleUrl(runnerId));
    return data;
  } catch (e) {
    const response = (e as { response?: { status?: number; data?: { code?: string } } } | null)
      ?.response;
    if (response?.status === 404 && response.data?.code === 'SCHEDULE_NOT_FOUND') return null;
    throw e;
  }
}

export async function saveRunnerSchedule(
  runnerId: string,
  schedule: RunnerSchedule
): Promise<RunnerSchedule> {
  const { data } = await api.put<RunnerSchedule>(scheduleUrl(runnerId), schedule);
  return data;
}

export async function deleteRunnerSchedule(runnerId: string): Promise<void> {
  await api.delete(scheduleUrl(runnerId));
}

export async function setRunnerScheduleEnabled(
  runnerId: string,
  enabled: boolean
): Promise<RunnerSchedule> {
  const { data } = await api.post<RunnerSchedule>(
    `${scheduleUrl(runnerId)}/${enabled ? 'enable' : 'disable'}`
  );
  return data;
}
